import { Box } from '@acko-tech/building-blocks.ui.common';
import { Text } from '@acko-tech/building-blocks.ui.typography';
import styled from 'styled-components';

export const FeaturesContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 106%;
  margin-top: 12px;
  background: #FFFFFF;
  overflow: hidden;
`;



export const Heading = styled(Text)`
  color: #000;
  font-family: "Euclid Circular B";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 20px;
`;

export const FeaturesScrollContainer = styled(Box)`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const FeaturesGridContainer = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  column-gap: 0px;
  row-gap: 20px;
  width: 100%;
  box-sizing: border-box;
`;

export const FeatureCard = styled(Box)`
  position: relative;
  width: 240px;
  height: 300px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;


export const VideoBackground = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
`;

export const ImageBackground = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
`;

export const CardContent = styled(Box)`
  position: relative;
  z-index: 2;
  padding: 24px 20px 20px 24px;
  background: linear-gradient(180deg, #000 -8.04%, rgba(67, 67, 67, 0.00) 70.52%, rgba(102, 102, 102, 0.00) 111.24%);
  height: 100%;
  display: flex;
  flex-direction: column;
  width: auto;
`;

export const CardTitle = styled(Text)`
    color: #FFF;
    font-family: "Euclid Circular B";
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 32px;
    margin-bottom: 8px;
`;

export const CardDescription = styled(Text)`
    color: rgba(255, 255, 255, 0.70);
    font-family: "Euclid Circular B";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
`;
